import React from 'react';

import { Modal } from '../../../../components';

import { BlackWarningIcon2 } from '../../../../assets/svg-image/common';

import PingFangSemiBoldText from '../../../../components/Text/PingFangSemiBoldText';
import PingFangRegularText from '../../../../components/Text/PingFangRegularText';
import { closeBlack } from '../../../../assets/Base64Image';
import Button from '../../../../components/Button';
import InterSemiBoldText from '../../../../components/Text/InterSemiBoldText';
import InterMediumText from '../../../../components/Text/InterMediumText';
import InterBoldText from '../../../../components/Text/InterBoldText';
import RowCenter from '../../../../components/Layout/RowCenter';

const CollectionRulesModal: React.FC<Props> = ({
  onClose,
  callback,
  isEnglish,
}) => {
  const modalWidth = 275;

  return (
    <Modal
      style={{ width: modalWidth, minWidth: 'unset', padding: 'unset', textAlign: 'center', paddingBottom: 15, borderRadius: 10 }}
    >
      {/* 图标 */}
      <div>
        <img src={BlackWarningIcon2} style={{ width: '72px', height: '71px', marginTop: '-35px' }} />
      </div>

      {/* 关闭图标 */}
      <div
        onClick={() => onClose()}
        style={{ padding: '10px', width: '30px', height: '30px', marginLeft: 'auto', marginRight: '10px', marginTop: '-35px' }}
      >
        <img src={closeBlack} style={{ width: '14px', height: '14px', marginTop: 8, marginLeft: 18 }} />
      </div>

      <RowCenter style={{ marginTop: 8 }}>
        {
          isEnglish ? (
            <InterSemiBoldText fontSize={20}>
              Collection Rules
            </InterSemiBoldText>
          ) : (
            <PingFangSemiBoldText fontSize={22}>
              领取规则
            </PingFangSemiBoldText>
          )
        }
      </RowCenter>

      <div style={{ width: 226, marginLeft: 'auto', marginRight: 'auto' }}>
        {
          isEnglish ? (
            <InterMediumText fontSize={14} lineHeight={18} textAlign={'center'} marginTop={10}>
              Deliveries may be removed if not collected in a timely manner.
            </InterMediumText>
          ) : (
            <PingFangRegularText fontSize={16} lineHeight={23} textAlign={'center'} marginTop={15}>
              若未能及时领取，派送的物品可能会被拿走。
            </PingFangRegularText>
          )
        }
      </div>

      <table style={{ marginTop: 10 }}>
        <tr>
          <td>
            <InterMediumText fontSize={24} textAlign={'right'} lineHeight={30}>
              Food
            </InterMediumText>
          </td>
          <td>
            <InterBoldText fontSize={24} color={'#00D2B9'} textAlign={'left'} marginLeft={10} lineHeight={30}>
              2 hours
            </InterBoldText>
          </td>
        </tr>
        <tr>
          <td>
            <InterMediumText fontSize={24} textAlign={'right'} lineHeight={30}>
              Parcels
            </InterMediumText>
          </td>
          <td>
            <InterBoldText fontSize={24} color={'#00D2B9'} textAlign={'left'} marginLeft={10} lineHeight={30}>
              48 hours
            </InterBoldText>
          </td>
        </tr>
      </table>

      {/* 分隔线 */}
      <div style={{ width: 214, height: 1, backgroundColor: '#000000', opacity: 0.5, margin: '10px auto 10px auto' }} />

      <RowCenter>
        <InterMediumText fontSize={14} lineHeight={18} textAlign={'center'} width={250}>
          You have authorised Foodifox to act as your agent to receive and digitally sign for parcels on your behalf.
        </InterMediumText>
      </RowCenter>

      <RowCenter style={{ marginTop: 20, marginBottom: 10 }}>
        <Button
          width={200}
          height={45}
          backgroundColor={'#00D2B9'}
          borderRadius={5}
          onClick={() => callback()}
        >
          {
            isEnglish ? (
              <InterMediumText fontSize={18} color={'#FFFFFF'}>
                Accept
              </InterMediumText>
            ) : (
              <PingFangSemiBoldText fontSize={18} color={'#FFFFFF'}>
                接受
              </PingFangSemiBoldText>
            )
          }
        </Button>
      </RowCenter>
    </Modal>
  );
};

export interface Props {
  onClose: () => void;
  callback: () => void;
  isEnglish: boolean;
}

export default CollectionRulesModal;
